// Resize embeds inside posts
(function($) {
	//On click of a video link, populate the iframe src and call Divi's fitvid
	$('p iframe').each(function() {
		$(this).parent().fitVids();
	});

})(jQuery);
